//import { RouteGroup } from "../core";
//import Hardware from './components/Hardware';
//import Software from './components/Software';
//import ElencoSegnalazioni from './components/ElencoSegnalazioni';
//import { Route } from "react-router";

export const NAME = "chiamate";

export const routes = {
    main: '/chiamate',
    hardware: '/chiamate/hardware',
    software: '/chiamate/software',
    elenco: '/chiamate/elenco',
}

//export const routes: RouteGroup = [
//    {
//        kind: "anagrafica",
//        path: '/chiamate/hardware',
//        icon: 'print',
//        //component: Hardware,
//        //render: moduli => moduli.chiamate
//    },
//    {
//        kind: "anagrafica",
//        path: '/chiamate/software',
//        icon: 'computer',
//        //component: Software,
//        //render: moduli => moduli.chiamate
//    },
//    { 
//        kind: "separator" 
//    },
//    {
//        kind: "anagrafica",
//        path: '/chiamate/elenco',
//        icon: 'list',
//        //component: ElencoSegnalazioni,
//        //render: moduli => {
//        //    return moduli.chiamate ? 
//        //    (<Route path='/portal/chiamate/elenco' component={ElencoSegnalazioni} />) :
//        //    undefined
//        //}
//    }
//]